import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography, Container } from '@mui/material';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import { useTenantInfo } from 'hooks/useTenantInfo';

import './Index.scss';

const DenyPrivacy = () => {
  const { t } = useLocales();
  const { tenantLogo } = useTenantInfo();

  return (
    <div className="deny-privacy-page__container">
      <div className="deny-privacy-page__card">
        <div className="deny-privacy-page__card-content">
          <div className="deny-privacy-page__logo">
            {tenantLogo ? (
                <Image url={tenantLogo} width={180} height={80} />
            ) : (
              <Image name="new-rec-logos.svg" width={60} height={60} />
            )}
          </div>
          
          <h1 className="deny-privacy-page__title">
            {t('We are sorry that you did not accepted our privacy terms')}
          </h1>
          
          <p className="deny-privacy-page__message">
            {t('Your account is now deleted in order to comply with the law, feel free to register again if you changed your idea!')}
          </p>

          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            className="deny-privacy-page__button"
          >
            {t('Go to Home')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DenyPrivacy;
